module.exports = __webpack_public_path__ + "img/done-icon.6fbf7928.png";